import { Box, Button, Card, Divider, Step, StepButton, StepConnector, StepIconProps, StepLabel, Stepper, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import SettingsIcon from "@mui/icons-material/Settings";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import VideoLabelIcon from "@mui/icons-material/VideoLabel";
import { stepConnectorClasses } from "@mui/material/StepConnector";
import MDTypography from "../../Components/MDTypography";
import FirstStep from "./Steps/firstStep";
import FieldDto from "../../Types/Api/DTO/FieldDto";
import { useDispatch, useSelector } from "react-redux";
import { ErrorToaast } from "../../utils/toast/Toast";
import SecondStep from "./Steps/secondStep";
import ThirdStep from "./Steps/thirdStep";
import ForthStep from "./Steps/forthStep";
import AppLoading from "../../Components/MDLoading";
import { GhabzDto } from "../../Types/Api/DTO/GhabzDto";
import FinalStep from "./Steps/finalStep";
import { conditionsParamsAction, selectedParamsAction, symboledParamsAction } from "../../Context/redux/actions";

const steps = ["انتخاب پارامتر", "نشانگذاری پارامتر", "مرحله سوم", "مرحله چهارم"];
const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    background: "rgb(63,94,251)",
    backgroundImage: "radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(164,70,252,1) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    background: "rgb(63,94,251)",
    backgroundImage: "radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(164,70,252,1) 100%)",
  }),
}));

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 25,
    color: "red",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      // border: 2,
      borderWidth: 2,
      borderImage: "radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(164,70,252,1) 100%)",
      borderStyle: "dotted",
      borderImageSlice: 1,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      height: 1,
      // border: 2,
      borderWidth: 2,
      borderImage: "radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(164,70,252,1) 100%)",
      borderStyle: "dotted",
      boxSizing: "content-box",
      borderImageSlice: 1,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 1,
    // border: 2,
    borderWidth: 2,
    borderColor: "gray",
    borderStyle: "dotted",
    boxSizing: "content-box",
    borderImageSlice: 1,
  },
}));
function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <SettingsIcon fontSize={"large"} />,
    2: <GroupAddIcon fontSize={"large"} />,
    3: <VideoLabelIcon fontSize={"large"} />,
    4: <VideoLabelIcon fontSize={"large"} />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}
function StepsPages(props: {
  activeStep: number;
  disabled: boolean;
  status: boolean;
  handleBack: any;
  handleNext: any;
  setLoading: any;
  loading: boolean;
  setFinalGhabz: any;
}): JSX.Element {
  let compo = <>ERROR: CONTACT WITH SUP</>;
  let otherProps = {
    handleNext: props.handleNext,
    handleBack: props.handleBack,
    status: props.status,
    disabled: props.disabled,
    loading: props.loading,
    setFinalGhabz: props.setFinalGhabz,
    setLoading: props.setLoading,
  };
  switch (props.activeStep) {
    case 1:
      compo = <FirstStep {...otherProps} />;
      break;
    case 2:
      compo = <SecondStep {...otherProps} />;
      break;
    case 3:
      compo = <ThirdStep {...otherProps} />;
      break;
    case 4:
      compo = <ForthStep {...otherProps} />;
      break;

    default:
      break;
  }
  return compo;
}
export default function Ghabz() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [loading, setLoading] = useState(false);
  const [FinalGhabz, setFinalGhabz] = useState<GhabzDto | null>(null);
  const dispatch = useDispatch();
  let selectedParams: FieldDto[] = useSelector((state: any) => state.selectedParams);
  const handleNext = () => {
    let newSkipped = skipped;
    if (selectedParams.length === 0) {
      return ErrorToaast("حداقل 1 پارامتر انتخاب شود");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);

    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  useEffect(() => {
    return () => {
      dispatch(conditionsParamsAction([]));
      dispatch(symboledParamsAction([]));
      dispatch(selectedParamsAction([]));
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar name={"قبض جدید"} />
      <Card sx={{ width: "100%", flex: 1 }}>
        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
          {steps.map((label, index) => {
            return (
              <Step key={label}>
                <StepButton color="inherit" onClick={handleStep(index)}>
                  <StepLabel StepIconComponent={ColorlibStepIcon}>
                    <MDTypography fontSize={12}>{label}</MDTypography>
                  </StepLabel>
                </StepButton>
              </Step>
            );
          })}
        </Stepper>
        <Divider />
        {activeStep === steps.length ? (
          <FinalStep FinalGhabz={FinalGhabz} />
        ) : (
          <React.Fragment>
            <StepsPages
              activeStep={activeStep + 1}
              disabled={activeStep === 0}
              handleBack={handleBack}
              handleNext={handleNext}
              status={activeStep === steps.length - 1}
              loading={loading}
              setLoading={setLoading}
              setFinalGhabz={setFinalGhabz}
            />
          </React.Fragment>
        )}
      </Card>
      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
